import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { translator } from 'mage-i18n';

import { PspContainer } from './PspContainer';

type ContainerTemplatePspProps = {
  children: React.ReactNode;
  contentWidth?: number;
  error?: any;
  info?: string;
  merchant?: any;
  scrollIntoView?: boolean;
  subtitle?: React.ReactNode;
  t: TranslatorFunction;
  tFrontEndError?: string;
  title?: string;
};

const ContainerTemplatePsp = (props: ContainerTemplatePspProps): React.JSX.Element => {
  const ref = useRef(null);
  const { scrollIntoView = false } = props;

  useEffect(() => {
    if (scrollIntoView && ref.current) {
      (ref.current as HTMLElement)?.scrollIntoView({ behavior: 'smooth' });
    }
  });

  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }}
      ref={ref}
    >
      {/* This form tag is added to allow submitting steps using the enter key, which triggers the
       call to action button instead of having to click next. For that to work, we need to override
       the default behaviour of the form and execute our own logic only. */}
      <PspContainer {...props} />
    </form>
  );
};

ContainerTemplatePsp.propTypes = {
  children: PropTypes.node.isRequired,
  t: PropTypes.func.isRequired,
  contentWidth: PropTypes.number,
  error: PropTypes.object,
  info: PropTypes.string,
  merchant: PropTypes.object,
  scrollIntoView: PropTypes.bool,
  subtitle: PropTypes.node,
  tFrontEndError: PropTypes.string,
  title: PropTypes.string,
};

export default connect(state => ({
  t: translator(state),
}))(ContainerTemplatePsp);
